export default __webpack_public_path__ + "img/67348ec7d917654fa4216c61499b8275.svg";